import { produce } from 'immer';

import { getUsers, cleanUsersList, addUser, updateUser, activateUser } from '../actions/users';

const initialState = {
  list: [],
  meta: {
    current_page: 1,
    per_page: 10,
  },
  loading: false,
  addUserLoading: false,
  updateUserLoading: false,
  loadings: {
    activateUser: {},
    updateUserPrev: {},
  },
};

const reducer = produce((state = initialState, action) => {
  switch (action.type) {
    // GET USERS LIST
    case getUsers.types.START:
      state.loading = true;
      return state;

    case getUsers.types.SUCCESS:
      state.list = action.payload.data;
      state.meta = action.payload.meta;
      state.loading = false;
      return state;

    case getUsers.types.FAIL:
      state.loading = false;
      return state;

    // CLEAN USERS LIST
    case cleanUsersList.types.INIT:
      state.list = initialState.list;
      state.meta = initialState.meta;
      return state;

    // ADD USER
    case addUser.types.START:
      state.addUserLoading = true;
      return state;

    case addUser.types.SUCCESS:
    case addUser.types.FAIL:
      state.addUserLoading = false;
      return state;

    // UPDATE USER
    case updateUser.types.START: {
      state.updateUserLoading = true;
      const { user_id, data } = action.payload;
      const current = state.list.find(item => item.id === user_id);

      if (current) {
        state.loadings.updateUserPrev[user_id] = {
          role: current.role,
          partner: current.partner,
        };
      }

      state.list = state.list.map(item => {
        if (item.id !== user_id) {
          return item;
        }

        return {
          ...item,
          role: data.role ? [data.role] : item.role,
          partner: data.partner !== undefined ? data.partner : item.partner,
        };
      });
      return state;
    }

    case updateUser.types.SUCCESS: {
      state.updateUserLoading = false;
      delete state.loadings.updateUserPrev[action.payload.user_id];
      return state;
    }

    case updateUser.types.FAIL: {
      state.updateUserLoading = false;
      const { user_id } = action.payload;
      const prev = state.loadings.updateUserPrev[user_id];

      if (prev) {
        state.list = state.list.map(item => {
          if (item.id !== user_id) {
            return item;
          }

          return {
            ...item,
            role: prev.role,
            partner: prev.partner,
          };
        });
        delete state.loadings.updateUserPrev[user_id];
      }
      return state;
    }

    // ACTIVATE USER
    case activateUser.types.START:
      state.loadings.activateUser[action.payload.user_id] = true;
      return state;

    case activateUser.types.SUCCESS:
      state.loadings.activateUser[action.payload.user_id] = false;
      state.list = state.list.map(item => {
        if (item.id === action.payload.user_id) {
          item.active = action.payload.active;
        }
        return item;
      });
      return state;

    case activateUser.types.FAIL:
      state.loadings.activateUser[action.payload.user_id] = false;
      return state;

    default:
      return state;
  }
});

export default reducer;
